/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface searchIconProps extends React.SVGAttributes<SVGElement> {
size?: string | number;
}
const searchIcon: React.FC<searchIconProps> = ({size, ...props}) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width={ size || "24" } height={ size || "24" } {...props}>
    <defs>
      <path d="M15.6833148,14.599485 L18.948366,17.8645362 C19.0264709,17.9426411 19.0264709,18.0692741 18.948366,18.147379 L18.147379,18.948366 C18.0692741,19.0264709 17.9426411,19.0264709 17.8645362,18.948366 L14.599485,15.6833148 C13.5928309,16.460073 12.3309067,16.9221278 10.9610639,16.9221278 C7.66885922,16.9221278 5,14.2532686 5,10.9610639 C5,7.66885922 7.66885922,5 10.9610639,5 C14.2532686,5 16.9221278,7.66885922 16.9221278,10.9610639 C16.9221278,12.3309067 16.460073,13.5928309 15.6833148,14.599485 Z M10.9559041,15.8331382 C13.6495261,15.8331382 15.8331382,13.6495261 15.8331382,10.9559041 C15.8331382,8.26228205 13.6495261,6.07866997 10.9559041,6.07866997 C8.26228205,6.07866997 6.07866997,8.26228205 6.07866997,10.9559041 C6.07866997,13.6495261 8.26228205,15.8331382 10.9559041,15.8331382 Z"
        id="path-1" />
    </defs>
    <g id="Icons-/-Search" stroke="none" fill="none" strokeWidth="1" fillRule="evenodd">
      <mask id="mask-2" fill="currentColor">
        <use xlinkHref="#path-1" />
      </mask>
      <use id="Search" fill="currentColor" fillRule="nonzero" xlinkHref="#path-1" />
      <path id="Rectangle" fill="currentColor" mask="url(#mask-2)" d="M0 0H24V24H0z" />
    </g>
  </svg>
);
searchIcon.displayName = 'searchIcon';
export default searchIcon;
/* tslint:enable */
/* eslint-enable */
